import CoremediaPage from '@ycos/nextjs/src/components/CoremediaPage'
import SingleColumnLayout from '@ycos/nextjs/src/page-layouts/SingleColumn'
import { iscPreset } from '@ycos/coremedia-renderer'
import { Navigation, NavigationItem, NavigationItemCta, SelectedNavRule } from '@ycos/component-navigation'
import Accordion from '@ycos/component-accordion'
import Block from '@ycos/component-block'
import Columns from '@ycos/component-columns'
import ContentCarousel from '@ycos/component-content-carousel'
import ContextualNotification from '@ycos/component-contextual-notification'
import Cta from '@ycos/component-cta'
import Divider from '@ycos/component-divider'
import { DuoFooter, FooterSection } from '@ycos/component-duofooter'
import Dropdown from '@ycos/component-dropdown'
import Hero from '@ycos/component-hero'
import Image from '@ycos/component-image'
import InfoField from '@ycos/component-info-field'
import List from '@ycos/component-list'
import LiveChat from '@ycos/component-live-chat'
import Quote from '@ycos/component-quote'
import StandardVideo from '@ycos/component-video'
import UserAttributesCollection from '@ycos/component-user-attributes-collection'
import getConfig from 'next/config'
import AppLayoutTracking from '../layouts/AppLayoutTracking'
import { InlineItems, InlineItem, ColumnList, DeliveryBlock, CookieSettings, DoNotSellConsent } from '../../src/components'
import lazyLoadRule from '../rules/LazyLoadRule'

const { publicRuntimeConfig } = getConfig()

function StaticPage({ theme, themeRtl = null, themeKr = null, themeJp = null, rules = [] }) {
  return CoremediaPage({
    layout: AppLayoutTracking({ theme, themeRtl, themeKr, themeJp }),
    rules: (props) => {
      return [
        ...iscPreset(publicRuntimeConfig, {
          isTestEnv: publicRuntimeConfig.isTestEnv,
          locale: props.locale,
        }),
        lazyLoadRule,
        SelectedNavRule(props.router),
        ...rules,
      ]
    },
    components: [
      Accordion,
      Block,
      ColumnList,
      ContentCarousel,
      ContextualNotification,
      CookieSettings,
      Cta,
      DeliveryBlock,
      Divider,
      Dropdown,
      DuoFooter,
      FooterSection,
      Hero,
      Image,
      InfoField,
      InlineItem,
      InlineItems,
      List,
      LiveChat,
      Navigation,
      NavigationItem,
      NavigationItemCta,
      Quote,
      SingleColumnLayout,
      StandardVideo,
      UserAttributesCollection,
      ...Columns,
      DoNotSellConsent,
    ],
  })
}

export default StaticPage
